<script setup>

import { Link, usePage } from "@inertiajs/vue3";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

const store = useStore();

import { scrollTop } from "@/utility";

// central store
const central = computed(() => store.state.central);

const page = usePage();

function findBySlug(data, slug) {

  if (!data) {
    return null;
  }

  let result = null;
  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    if (item.route.slug === slug) {
      return item;
    }
    if (item.children && item.children.length > 0) {
      result = findBySlug(item.children, slug);
      if (result) {
        break;
      }
    }
  }
  return result;
}

const currentCategory = computed(() => {

  if (!central.value.main_navigation_data)
    return null;

  return findBySlug(central.value.main_navigation_data[page.props.locale], route().params.slug);
});

</script>

<template>

  <ul class="subcategories" v-if="currentCategory && currentCategory.children?.length">
    <li>
      <span class="text-grey text-small">
        Subcategorii:
      </span>
    </li>
    <li v-for="(child, childKey) in currentCategory.children">
      <Link :href="route('catchall', child.route.slug, false)" :alt="child.title" :onFinish="scrollTop">
        <span class="subcategory-title text-primary">{{ child.title }}</span>
      </Link>
    </li>

  </ul>

</template>

<script>
export default {
  name: "SubNavigation"
};
</script>